module.exports = __webpack_public_path__ + "img/elo.ce59d23c.svg";